import clsx from "clsx";
import { logoOxoneWhite, iconFb, iconIg, iconYt } from "../../assets/images";
import styles from "./styles.module.scss";

const dataSiteMap = [
  { title: "Tentang Kami" },
  { title: "Jurnal" },
  { title: "Hubungi Kami" },
  { title: "Privacy Policy" },
  { title: "Oxone World" },
];

const dataSocial = [
  { title: "fb", icon: iconFb },
  { title: "ig", icon: iconIg },
  { title: "yt", icon: iconYt },
];

function Footer() {
  return (
    <footer className={clsx(styles.footer)}>
      <div className={clsx("py-8", styles.container)}>
        <div className="pb-4 flex flex-wrap lg:border-b lg:border-white">
          <div className="w-full lg:w-3/12">
            <img
              src={logoOxoneWhite}
              width={150}
              height={60}
              alt="logo_oxone"
            />
            <p className="mt-8 text-sm text-white">
              Be a chef at your own home
            </p>
            <p className="mt-12 text-sm text-white">oxone.official@gmail.com</p>
            <p className="mt-4 text-sm text-white">+62 859-5988-3300</p>
          </div>
          <div className="mt-6 lg:m-0 lg:w-6/12 py-8 flex flex-wrap">
            {dataSiteMap?.map((item, index) => (
              <a
                key={index}
                className={clsx(
                  "w-full lg:w-1/2 cursor-pointer text-sm text-white",
                  {
                    "mt-6 lg:m-0": index !== 0,
                    "order-0": index === 0,
                    "order-1 lg:order-2": index === 2,
                    "order-2 lg:order-4": index === 4,
                    "order-3 mt-16 lg:order-1": index === 1,
                    "order-4 lg:order-3": index === 3,
                  }
                )}
                href="#"
              >
                {item?.title}
              </a>
            ))}
          </div>
          <div className="w-full lg:w-3/12 py-6">
            <p className={clsx("text-white text-xl", styles.fontPrimary)}>
              Follow Us on Social Media
            </p>
            <div className="mt-8 flex">
              {dataSocial?.map((item, index) => (
                <div
                  key={item?.title}
                  className={clsx("cursor-pointer", { "ml-4": index !== 0 })}
                >
                  <img
                    src={item?.icon}
                    alt={item?.title}
                    width={32}
                    height={32}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <p className="py-4 text-sm text-white text-center lg:text-left">
          &copy;2022 Oxone All rights reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
